"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalHelp = void 0;
const react_1 = __importDefault(require("react"));
const medical_help_1 = __importDefault(require("../icons-path/medical-help"));
const icons_svg_1 = require("../icons-svg");
require("../icons.types");
const MedicalHelp = (props) => {
    return react_1.default.createElement(icons_svg_1.IconsSvg, Object.assign({}, props, { path: medical_help_1.default }));
};
exports.MedicalHelp = MedicalHelp;
